module.exports = "<div class=\"tilebar-panel\" *ngIf=\"tiles\">\r\n    <div *ngFor=\"let tile of getTiles()\" [class.selected]=\"tile==currentTile\" [class.separator]=\"tile=='|'\">\r\n        <img *ngIf=\"tile!='|'\" [src]=\"getTileImage(tile)\" (click)=\"setCurrentTile(tile)\"/>\r\n        <hr style=\"width: 90%\" *ngIf=\"tile=='|'\" />\r\n    </div>\r\n    \r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/tilesbar/tilesbar.component.html
// module id = ./src/app/layout/tilesbar/tilesbar.component.html
// module chunks = main